import * as types from '../mutation-types';
import { Module } from 'vuex';

interface State {
  filters: any;
}

const initialState = {
  filters: {},
};

const headersModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    filters: state => state.filters,
  },
  actions: {
    getFilter({ state }, key: string) {
      const filter = state.filters[key];
      if (filter) return JSON.parse(JSON.stringify(filter));
    },
    setFilter({ commit }, { key, filter }) {
      commit(types.SET_FILTER, { key, filter });
    },
  },
  mutations: {
    [types.SET_FILTER](state: State, { key, filter }) {
      state.filters[key] = filter;
    },
  },
};

export default headersModule;
